interface Opts {
  defaults?: Record<string, any>;
  static?: Record<string, any>;
}

function makeStruct(name: string, keys: string[], givenOpts: Opts = {}) {
  const struct = (...args: any[]) => {
    const opts: Opts = {
      defaults: {},
      static: {},
      ...givenOpts,
    };

    const instance = keys.reduce((acc, key, idx) => {
      if (args[idx] === undefined) acc[key] = opts.defaults[key];
      else acc[key] = args[idx];
      return acc;
    }, opts.static);

    instance._name = name;
    return instance;
  };

  struct.is = (s: any) => s && typeof s === "object" && s._name === name;
  return struct;
}

export function makePssError(name: string) {
  return makeStruct(name, ["data", "error", "subError"], {
    defaults: {
      data: {},
      error: name,
      subError: null,
    },
    static: { isPssError: true },
  });
}
